import { Button } from '@property.com.au/ui-kit';
import { useContext, useState } from 'react';
import { PcaMapContext } from '../../../../../property-page/contexts/PcaMapContext/PcaMapContext';

import { exitFullscreen, requestFullscreen } from './helpers/requestFullscreen';
import Contract from '../icons/Contract';
import Expand from '../icons/Expand';
import { isHopefullyDomEnvironment } from '../../../../../helpers/IsHopefullyDomEnvironment';

export const isFullScreenUnsupported = (userAgent: string = 'unknown'): boolean => {
  return /iPhone/.test(userAgent);
};
export const FullScreenButton = () => {
  const { map } = useContext(PcaMapContext);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const isClientSideRender = isHopefullyDomEnvironment();
  const toggleFullScreen = () => {
    const elementToSendFullscreen = map?.getDiv().firstChild as HTMLElement;

    if (!elementToSendFullscreen) return;
    if (isFullScreen) exitFullscreen();
    else requestFullscreen(elementToSendFullscreen);
    setIsFullScreen(!isFullScreen);
  };
  return isClientSideRender && isFullScreenUnsupported(navigator.userAgent) ? null : (
    <Button
      compact
      hideLabel
      onClick={toggleFullScreen}
      variant="map-icon"
      sizeVariant="medium"
      icon={isFullScreen ? <Contract /> : <Expand />}
    >
      Full screen
    </Button>
  );
};
